import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import cx from 'classnames';
import { ControlInputContainer } from '../ControlInputContainer';
import { useDeviceType } from '../../../responsive';
import { getStyles } from './styles';

/**
 * Компонент radio/checkbox похожего на прозрачную кнопку
 *
 * @export
 * @param {IControlButtonProps} props
 * @returns
 */
export var ControlButton = /*#__PURE__*/React.forwardRef(function ControlButton(props, ref) {
  var disabled = props.disabled,
      invalid = props.invalid,
      label = props.label;
  var deviceType = useDeviceType();
  var styles = getStyles(deviceType);
  return /*#__PURE__*/React.createElement(ControlInputContainer, _extends({}, props, {
    className: cx(styles['control-button'], disabled && styles['disabled'], invalid && styles['invalid']),
    ref: ref
  }), /*#__PURE__*/React.createElement("span", {
    className: cx(styles['button'])
  }, label));
});